export default __webpack_public_path__ + "static/media/dead-corona.00313c00.png";